import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  exp: number;
}

export const isTokenExpired = (token: string): boolean => {
  if (!token) return true;
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;
    return !decoded.exp || decoded.exp < currentTime;
  } catch {
    return true;
  }
};

export const logout = (): void => {
  localStorage.removeItem("accessToken");
  window.location.href = "/login";
};
